class BrixRichText {
  static init(...parameters) {
    return new BrixRichText(...parameters);
  }

  constructor(block) {
    if (block) {
      this.block = block;

      // Content slide in animation
      if (block.classList.contains('slideInContent')) {
        const blockContent = block.querySelector('.content').childNodes;
        const contentArray = [...blockContent];
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < contentArray.length; i++) {
          const child = contentArray[i];
          if (child.nodeType === 1) {
            child.classList.add('animate-me');
            child.classList.add('slideInBottom');
          }
        }
      }
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-rich-text', BrixRichText.init);
}
